import { render, staticRenderFns } from "./ClassPpt.vue?vue&type=template&id=9323b6f6&scoped=true&"
import script from "./ClassPpt.vue?vue&type=script&lang=js&"
export * from "./ClassPpt.vue?vue&type=script&lang=js&"
import style0 from "./ClassPpt.vue?vue&type=style&index=0&id=9323b6f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9323b6f6",
  null
  
)

export default component.exports